import React, { useContext, useMemo } from 'react'
import { Variants } from '../ButtonVariant/variants'

type ToggleButtonContextValue = {
  onVariant: Variants
  offVariant: Variants
  value: string
}

const ToggleButtonContext = React.createContext<
  ToggleButtonContextValue | undefined
>(undefined)

export const ToggleButtonProvider: React.FC<
  React.PropsWithChildren<ToggleButtonContextValue>
> = ({ children, onVariant, offVariant, value }) => {
  const providedValue = useMemo(
    () => ({ onVariant, offVariant, value }),
    [offVariant, onVariant, value]
  )

  return (
    <ToggleButtonContext.Provider value={providedValue}>
      {children}
    </ToggleButtonContext.Provider>
  )
}

export const useToggleButton = () => {
  const context = useContext(ToggleButtonContext)

  if (!context) {
    throw new Error(
      'useToggleButton must be used within a ToggleButtonProvider'
    )
  }

  return context
}
